import { Table } from 'semantic-ui-react';
import data from '../data/data.json';

const Tables = () => {
    return (
        <div id="third-data" className="third-tabbed-content">
            <Table unstackable compact className="pew-chart">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Year</Table.HeaderCell>
                        <Table.HeaderCell data-color="#5b8e83">
                            U.S.
                        </Table.HeaderCell>
                        <Table.HeaderCell data-color="#5B8E83">
                            Germany
                        </Table.HeaderCell>
                        <Table.HeaderCell data-color="#5B8E83">
                            Italy
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {data.map(d => (
                        <Table.Row textAlign="right">
                            <Table.Cell>{d.year}</Table.Cell>
                            <Table.Cell>{d.us}</Table.Cell>
                            <Table.Cell>{d.germany}</Table.Cell>
                            <Table.Cell>{d.italy}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};

export default Tables;
